import { createToaster } from "@meforma/vue-toaster";

const options = {
  position: 'top-right',
}
const toaster = createToaster(options);

export default toaster